import React, { useEffect } from 'react'
import { MultiSelect } from 'primereact/multiselect'
import storage from '../../services/stoage.service'
import utils from '../../utils'
import { textoAgendamento } from './textos'
import { unidadesTravadas } from './agendamentoRelatorio.utils'

/**
 * Editor do filtro de unidades ({ unidades: [{ id, value }] }) no AgendarRelatorioDialog. Sem unidade marcada, o
 * relatorio considera todas as da empresa (como na tela do DRE). Usuario de unidade unica so agenda a propria: o
 * seletor fica desabilitado e o filtro e forcado para ela (ver unidadesTravadas).
 */
export const EditorFiltrosUnidades = ({ filtros, onChange }) => {
  const travadas = unidadesTravadas(storage.getUsuarioUnidadeUnica(), storage.getUnit())
  const opcoes = utils.convertArrayIdValueToIdLabel(utils.getListIdValuesUnidadeFromEmpresa(storage.getCompany()))
  const atuais = filtros.unidades

  useEffect(() => {
    if (travadas && JSON.stringify(atuais) !== JSON.stringify(travadas)) {
      onChange('unidades', travadas)
    }
  }, [atuais]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="p-col-12">
      <label className="label">{textoAgendamento('unidade')}</label>
      <MultiSelect
        value={utils.convertArrayIdValueToIdLabel(travadas || atuais)}
        options={opcoes}
        optionLabel="label"
        dataKey="id"
        selectedItemsLabel={textoAgendamento('unidade.selecionadas')}
        disabled={Boolean(travadas)}
        onChange={(e) => onChange('unidades', utils.convertArrayIdLabelToIdValue(e.value))}
      />
    </div>
  )
}
